import { render, staticRenderFns } from "./PopUpTraitement.vue?vue&type=template&id=6364dbc7&scoped=true"
import script from "./PopUpTraitement.vue?vue&type=script&lang=js"
export * from "./PopUpTraitement.vue?vue&type=script&lang=js"
import style0 from "./PopUpTraitement.vue?vue&type=style&index=0&id=6364dbc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6364dbc7",
  null
  
)

export default component.exports